import { render, staticRenderFns } from "./RelatedFAQList.vue?vue&type=template&id=c47990a0&"
import script from "./RelatedFAQList.vue?vue&type=script&lang=ts&"
export * from "./RelatedFAQList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports